import { 
    SET_ASSET_MODAL_OPTIONS
  }  from "../actions/actionTypes";

  const initialState = {
    assetModalOptions:{}
   }
  
  function AssetRedux(state = initialState, action) {
    switch (action.type) {
       case SET_ASSET_MODAL_OPTIONS:
           return {
               ...state,
               assetModalOptions: action.payload
           }
      default:
        return state
    }
  }
  
  export default AssetRedux;